import React, { Component } from "react";
// import styled from 'styled-components'
import { Box, Card, Flex, Heading, Text } from "rebass";
import { Block, Tabs } from "reakit";
import {
  Content,
  DesktopBox,
  MobileHeader,
  PositionBox,
  TabHeader,
} from "../../components/Base";
import AirportTab from "../../components/AirportTab";
import { AddButton } from "../../components/Base/Buttons";
import { LeavesCard } from "../../components/Cards";
import { sortBy } from "lodash-es";
import { leavesActions, leavesSelectors } from "../../store/leaves";
import { connect } from "react-redux";
import { ApplyLeaveFilters } from "../../components/Search";
import { leaveUtils } from "../../utils";
import BasicSearch from "../../components/Forms/BasicSearch";

import Loading from "../../components/Base/Loading";

class Airport extends Component {
  state = {
    all: [],
    leaves: [],
    pending: [],
    approved: [],
    returning: [],
    history: [],
    searchTerm: "",
    width: 0,
    height: 0,
    loadingLeaves: null,
    students: null,
  };

  componentDidMount() {
    const { profile, isFaculty } = this.props;

    if (isFaculty) {
      this.getLeaves("PENDING");
    } else {
      this.listener = this.getStudentLeaves(profile.id);
    }
    window.addEventListener("resize", this.updateWindowDimensions);
    this.updateWindowDimensions();
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  };

  getLeaves = async (type) => {
    const { updateList } = this.props;

    let result = [];

    this.setState({ loadingLeaves: true });

    if (this.state.students === null) {
      const studentsRef = await this.props.firebase.students().get();
      let newStudents = [];
      studentsRef.forEach((doc) =>
        newStudents.push({ id: doc.id, ...doc.data() })
      );
      this.setState({ students: newStudents });
    }

    await this.props.firebase
      .leaves()
      .where("true_status", "==", type)
      .get()
      .then((snapshot) => {
        if (snapshot.docs) {
          snapshot.docs.map((doc) => {
            const leaveId = doc.id;
            const leave = doc.data();

            result.push({
              id: leaveId,
              student_details: this.state.students.find(
                (item) => item.id === leave.student_uid
              ),
              ...leave,
            });
          });
          updateList(result);
        }
      });

    this.setState({ loadingLeaves: false });
  };

  // For Students - Gets all leaves
  getStudentLeaves = (id) => {
    const { updatePending, updateHistory } = this.props;

    return this.props.firebase
      .leaves()
      .where("student_uid", "==", id)
      .orderBy("post_time", "desc")
      .onSnapshot((snapshot) => {
        if (snapshot.docs) {
          let pendingResult = [];
          let historyResult = [];
          snapshot.docs.map((doc) => {
            let leaveId = doc.id;
            let leave = doc.data();
            if (leave.true_status === "PENDING") {
              pendingResult.push({ id: leaveId, ...leave });
            } else {
              historyResult.push({ id: leaveId, ...leave });
            }
          });
          this.setState({ loading: false });
          updatePending(pendingResult);
          updateHistory(historyResult);
        }
      });
  };

  // Sorts leaves for faculty
  sortLeaves = (leaves) => {
    let sortedLeaves = [];
    if (leaves.length > 0 && leaves[0].last_name) {
      sortedLeaves = sortBy(leaves, "last_name");
    } else {
      sortedLeaves = sortBy(leaves, "start_date");
    }
    return sortedLeaves;
  };

  handleSearchInput = (e) => {
    this.setState({ searchTerm: e.target.value });
  };

  handleFilterLeaves = (leaves, filters) => {
    const { searchTerm } = this.state;

    const leaveFilters = filters.leaves;
    const studentFilters = filters.student;
    let result = leaveUtils.filterLeaveResults(leaves, leaveFilters);
    result = leaveUtils.filterLeaveDetailsByStudentName(result, searchTerm);
    result = leaveUtils.filterLeavesByStudent(studentFilters, result);

    return leaveUtils.sortLeaves(result);
  };

  componentWillUnmount() {
    const { isFaculty } = this.props;
    if (isFaculty) {
      // this.getStudentListener();
      // this.pendingListener();
      // this.approvedListener();
      // this.returningListner()
    } else {
      this.listener();
      //this.history();
    }
    window.removeEventListener("resize", this.updateWindowDimensions);
    this.updateWindowDimensions();
  }

  getCurrentIndex = () => {
    const leave_type = localStorage.getItem("leaveTypes");
    let currentTabIndex = 0;
    switch (leave_type) {
      case "pending":
        currentTabIndex = 0;
        break;
      case "history":
        currentTabIndex = 1;
        break;
      default:
        currentTabIndex = 0;
        break;
    }

    return { current: currentTabIndex };
  };

  render() {
    const { searchTerm, loadingLeaves } = this.state;
    const {
      isFaculty,
      pending,
      history,
      profile,
      updateFilter,
      filters,
      clearFilter,
      school,
      currentTabIndex,
    } = this.props;
    let { all } = this.props;
    all = this.sortLeaves(all);

    let leaveTypesData = [];
    if (school) {
      leaveTypesData = school.leaveTypes;
    }

    const sortedPending = pending;
    const sortedHistory = history;

    let pendingList = this.handleFilterLeaves(all, filters[0]);
    let leavingList = this.handleFilterLeaves(all, filters[1]);
    let returningList = this.handleFilterLeaves(all, filters[2]);
    let declinedList = this.handleFilterLeaves(all, filters[2]);

    return (
      <Box>
        {isFaculty ? (
          <Tabs.Container initialState={{ current: currentTabIndex }}>
            {(tabs) => (
              <Block>
                <Tabs>
                  <MobileHeader maxHeight={"131px"} height={"119px"}>
                    <Heading pt={"4px"} pb={"8px"}>
                      Leaves
                    </Heading>
                    <ApplyLeaveFilters
                      current={tabs.current}
                      filters={filters[tabs.current]}
                      updateFilters={updateFilter}
                      clearFilter={clearFilter}
                    />
                    <Tabs.Tab
                      tab="Pending"
                      {...tabs}
                      style={{ paddingLeft: "0" }}
                      onClick={() => this.getLeaves("PENDING")}
                    >
                      <TabHeader title={"Pending"} />
                    </Tabs.Tab>
                    <Tabs.Tab
                      tab="Leaving"
                      {...tabs}
                      onClick={() => this.getLeaves("LEAVING")}
                    >
                      <TabHeader title={"Leaving"} />
                    </Tabs.Tab>
                    <Tabs.Tab
                      tab="Returning"
                      {...tabs}
                      onClick={() => this.getLeaves("RETURNING")}
                    >
                      <TabHeader title={"Returning"} />
                    </Tabs.Tab>
                    <Tabs.Tab
                      tab="Declined"
                      {...tabs}
                      onClick={() => this.getLeaves("DECLINED")}
                    >
                      <TabHeader title={"Declined"} />
                    </Tabs.Tab>
                  </MobileHeader>
                  <MobileHeader
                    paddingLeft={"0"}
                    paddingRight={"0"}
                    paddingTop={"0"}
                    top={"150px"}
                  >
                    <PositionBox position={"relative"} left={0} bottom={"1px"}>
                      <BasicSearch
                        mr={1}
                        handleInput={this.handleSearchInput}
                        placeholder={"Search Students.."}
                        search={searchTerm}
                      />
                    </PositionBox>
                  </MobileHeader>
                  <DesktopBox ml={"42px"} pt={"10px"}>
                    <Tabs.Tab
                      tab="Pending"
                      stopId="Pending"
                      {...tabs}
                      onClick={() => this.getLeaves("PENDING")}
                    >
                      <TabHeader title={"Pending"} />
                    </Tabs.Tab>
                    <Tabs.Tab
                      tab="Leaving"
                      stopId="Leaving"
                      {...tabs}
                      onClick={() => this.getLeaves("LEAVING")}
                    >
                      <TabHeader title={"Leaving"} />
                    </Tabs.Tab>
                    <Tabs.Tab
                      tab="Returning"
                      stopId="Returning"
                      {...tabs}
                      onClick={() => this.getLeaves("RETURNING")}
                    >
                      <TabHeader title={"Returning"} />
                    </Tabs.Tab>

                    <Tabs.Tab
                      tab="Declined"
                      stopId="Declined"
                      {...tabs}
                      onClick={() => this.getLeaves("DECLINED")}
                    >
                      <TabHeader title={"Declined"} />
                    </Tabs.Tab>
                  </DesktopBox>
                </Tabs>

                <Content p={[0, 3]} pt={[0, 2]}>
                  {profile && !profile.is_admin && isFaculty ? null : (
                    <Box pt={[0, 2]} pl={[0, 3]} pb={[0, 3]}>
                      <AddButton to="/app/leaves/new" />
                    </Box>
                  )}
                  <Tabs.Panel stopId="Pending" tab="Pending" {...tabs}>
                    {loadingLeaves ? (
                      <Loading />
                    ) : (
                      <React.Fragment>
                        {!all.length && leaveTypesData ? (
                          <Text
                            pt={2}
                            pb={3}
                            fontSize={"16px"}
                            fontWeight={400}
                          >
                            There are currently no leaves.
                          </Text>
                        ) : null}
                        {Object.keys(leaveTypesData).length > 0 && (
                          <AirportTab
                            type="Pending"
                            isFaculty={isFaculty}
                            profile={profile}
                            leaves={pendingList}
                            types={leaveTypesData}
                          />
                        )}
                      </React.Fragment>
                    )}
                  </Tabs.Panel>

                  <Tabs.Panel stopId="Leaving" tab="Leaving" {...tabs}>
                    {loadingLeaves ? (
                      <Loading />
                    ) : (
                      <React.Fragment>
                        {!leavingList.length && leaveTypesData ? (
                          <Text
                            pt={2}
                            pb={3}
                            fontSize={"16px"}
                            fontWeight={400}
                          >
                            There are currently no leaves.
                          </Text>
                        ) : null}
                        {Object.keys(leaveTypesData).length > 0 && (
                          <AirportTab
                            type="Leaving"
                            isFaculty={isFaculty}
                            profile={profile}
                            leaves={leavingList}
                            types={leaveTypesData}
                          />
                        )}
                      </React.Fragment>
                    )}
                  </Tabs.Panel>
                  <Tabs.Panel stopId="Returning" tab="Returning" {...tabs}>
                    {loadingLeaves ? (
                      <Loading />
                    ) : (
                      <React.Fragment>
                        {!returningList.length && leaveTypesData ? (
                          <Text
                            pt={2}
                            pb={3}
                            fontSize={"16px"}
                            fontWeight={400}
                          >
                            There are currently no leaves.
                          </Text>
                        ) : null}
                        {Object.keys(leaveTypesData).length > 0 && (
                          <AirportTab
                            type="Returning"
                            isFaculty={isFaculty}
                            leaves={returningList}
                            types={leaveTypesData}
                            profile={profile}
                          />
                        )}
                      </React.Fragment>
                    )}
                  </Tabs.Panel>

                  <Tabs.Panel stopId="Declined" tab="Declined" {...tabs}>
                    {loadingLeaves ? (
                      <Loading />
                    ) : (
                      <React.Fragment>
                        {!declinedList.length && leaveTypesData ? (
                          <Text
                            pt={2}
                            pb={3}
                            fontSize={"16px"}
                            fontWeight={400}
                          >
                            There are currently no leaves.
                          </Text>
                        ) : null}
                        {Object.keys(leaveTypesData).length > 0 && (
                          <AirportTab
                            type="Declined"
                            isFaculty={isFaculty}
                            leaves={declinedList}
                            types={leaveTypesData}
                            profile={profile}
                          />
                        )}
                      </React.Fragment>
                    )}
                  </Tabs.Panel>
                </Content>
              </Block>
            )}
          </Tabs.Container>
        ) : (
          <Tabs.Container initialState={this.getCurrentIndex()}>
            {(tabs) => (
              <Block>
                {this.state.width < 700 ? (
                  <Tabs>
                    <MobileHeader>
                      <Heading pt={1}>Leaves</Heading>

                      <Tabs.Tab tab="Pending" {...tabs}>
                        <TabHeader title={"Pending"} />
                      </Tabs.Tab>
                      <Tabs.Tab tab="History" {...tabs}>
                        <TabHeader title={"History"} />
                      </Tabs.Tab>
                    </MobileHeader>
                  </Tabs>
                ) : (
                  <Tabs>
                    <DesktopBox ml={"42px"}>
                      <Tabs.Tab tab="pending" {...tabs}>
                        <TabHeader title={"Pending"} />
                      </Tabs.Tab>
                      <Tabs.Tab tab="history" {...tabs}>
                        <TabHeader title={"History"} />
                      </Tabs.Tab>
                    </DesktopBox>
                  </Tabs>
                )}

                <Content p={[0, 3]} pt={[0, 2]}>
                  {profile && !profile.is_admin && isFaculty ? null : (
                    <Box pt={[0, 2]} pl={[0, 3]} pb={[0, 3]}>
                      <AddButton to="/app/leaves/new" />
                    </Box>
                  )}
                  <Tabs.Panel
                    tab={this.state.width < 700 ? "Pending" : "pending"}
                    {...tabs}
                  >
                    <Box p={2} pb={[5, 0]}>
                      {sortedPending.map((item) => (
                        <LeavesCard
                          key={item.id}
                          details={item}
                          variant="leaves"
                          types={leaveTypesData}
                          hideName
                          leaveTypes="pending"
                        />
                      ))}
                    </Box>
                  </Tabs.Panel>

                  <Tabs.Panel
                    tab={this.state.width < 700 ? "History" : "history"}
                    {...tabs}
                  >
                    {profile.on_leave && (
                      <React.Fragment>
                        <Heading
                          pl={3}
                          as={"h6"}
                          style={{ marginTop: "1em", marginBottom: "1em" }}
                        >
                          You are currently on leave
                        </Heading>
                        <Box pb={0}>
                          {sortedHistory
                            .filter((leave) => leave.status === 11)
                            .map((item) => (
                              <Card
                                borderRadius={8}
                                boxShadow="0 0px 6px -1px rgba(0,0,0,0.15), 0 0px 4px -1px rgba(0,0,0,0.1)"
                                p={"18px 12px"}
                                mb={3}
                              >
                                <LeavesCard
                                  key={item.id}
                                  details={item}
                                  types={leaveTypesData}
                                  noBorder
                                  hideName
                                  leaveTypes="history"
                                />
                              </Card>
                            ))}
                        </Box>
                      </React.Fragment>
                    )}

                    <Box p={2} pb={[5, 0]}>
                      {sortedHistory.map((item) => (
                        <LeavesCard
                          key={item.id}
                          details={item}
                          variant="leaves"
                          types={leaveTypesData}
                          hideName
                          leaveTypes="history"
                        />
                      ))}
                    </Box>
                  </Tabs.Panel>
                </Content>
              </Block>
            )}
          </Tabs.Container>
        )}
      </Box>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: leavesSelectors.isLoading(state.leaves),
  all: leavesSelectors.refreshList(state.leaves),
  pending: leavesSelectors.refreshPending(state.leaves),
  history: leavesSelectors.refreshHistory(state.leaves),
  filters: leavesSelectors.refreshFilters(state.leaves),
});

const mapDispatchToProps = (dispatch) => ({
  updateList: (data) => dispatch(leavesActions.updateList(data)),
  updatePending: (data) => dispatch(leavesActions.updatePending(data)),
  updateHistory: (data) => dispatch(leavesActions.updateHistory(data)),
  updateFilter: (filters, type, tab) =>
    dispatch(leavesActions.updateFilter(filters, type, tab)),
  clearFilter: (type, tab) => dispatch(leavesActions.clearFilter(type, tab)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Airport);
